import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AlarmHistoryHeader from './AlarmHistoryHeader';
import { ALM_SMM_DAT } from '../../molecules/Grid/AlarmGrid';
import { useModal } from '../../../function/useModal';
import ImageDialog, { ImageDialogResponse } from '../../molecules/Dialog/ImageDialog';
import AlarmSummaryGrid, { AlarmDatas } from '../AlarmSummary/AlarmSummaryGrid';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { DownloadFile } from '../../molecules/CSVExport/CSVDownload';
import dayjs from 'dayjs';
import { ConvertKind } from '../../molecules/Div/AlarmKindDiv';
import { ConvertState } from '../../molecules/Div/AlarmStateDiv';
import { useTranslation } from 'react-i18next';

type AlarmHistoryProps = {};

type ImageResponse = {
  Filepath: string;
};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 326px)',
      overflowY: 'scroll',
    },
  })
);

const AlarmHistoryPage: React.FC<AlarmHistoryProps> = (props: AlarmHistoryProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  console.log('== AlarmHistory ==');
  const [alarmArray, setAlarmArray] = useState<AlarmDatas>();
  const [selIdx, setSelIdx] = useState<number>(0);
  const [flgDlg, actDlg] = useModal<ImageDialogResponse>();
  const [imgPath, setImgPath] = useState<string>('');
  const [searchRange, setSearchRange] = useState<string>('');

  const dlg = flgDlg ? (
    <ImageDialog dialog={actDlg} imagePath={imgPath} imageWidht={'100%'} imageHeigth={'100%'} title={imgPath} />
  ) : null;

  // CSV出力
  const exportButtonAction = () => {
    if (alarmArray) {
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      let header = `${t('AlarmSummaryGrid.日時', '日時')},${t('AlarmSummaryGrid.区分', '区分')},${t(
        'AlarmSummaryGrid.機器番号',
        '機器番号'
      )},${t('AlarmSummaryGrid.機器名称', '機器名称')},${t('AlarmSummaryGrid.項目名称', '項目名称')},${t(
        'AlarmSummaryGrid.異常種別',
        '異常種別'
      )},${t('AlarmSummaryGrid.メッセージ', 'メッセージ')},${t('AlarmSummaryGrid.状態', '状態')},${t(
        'AlarmSummaryGrid.検出値',
        '検出値'
      )},${t('AlarmSummaryGrid.閾値', '閾値')},${t('AlarmSummaryGrid.判定条件番号', '判定条件番号')},${t(
        'AlarmSummaryGrid.PLCNo',
        'PLCNo.'
      )},${t('AlarmSummaryGrid.AIカード', 'AIカード')},${t('AlarmSummaryGrid.CH番号', 'CH番号')}\n`;
      let alarms = alarmArray.map<string>((alm) => {
        let day = dayjs(alm.ALM_SMM_DAT.COL_DATE);
        let kind = ConvertKind(alm.ALM_SMM_DAT.ALM_KIND, t);
        let stat = ConvertState(alm.ALM_SMM_DAT.STAT, alm.ALM_SMM_DAT.DEV_NAME, t);
        return `${day.format('YY/MM/DD HH:mm:ss')},${kind},${alm.ALM_SMM_DAT.DEV_NO},${alm.ALM_SMM_DAT.DEV_NAME},${
          alm.ALM_SMM_DAT.ITM_NAME
        },${alm.ALM_KIND_SET?.TYP_NAME ?? ''},${alm.ALM_SMM_DAT.MESSAGE},${stat},${alm.ALM_SMM_DAT.DATA},${
          alm.ALM_SMM_DAT.LIMIT
        },${alm.ALM_SMM_DAT.JUDGE_NO},${alm.ALM_SMM_DAT.PLC_NO},${alm.ALM_SMM_DAT.AI_CARD},${alm.ALM_SMM_DAT.AI_CH}\n`;
      });
      let blob = new Blob([bom, header].concat(alarms), { type: 'text/csv' });
      let range = searchRange.replaceAll('-', '').replaceAll(' ', '').replaceAll(':', '');
      let filename = `AlarmHistory_${range}.csv`;
      DownloadFile(filename, blob);
    }
  };

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 0 }}>
      <Grid item xs={12}>
        <AlarmHistoryHeader
          setAlarmList={setAlarmArray}
          setSearchRange={setSearchRange}
          exportButton={exportButtonAction}
        />
      </Grid>
      <Grid item xs={12}>
        <AlarmSummaryGrid
          alarmArray={alarmArray}
          alarmContainerStyle={classes.tableContainer}
          selectIndex={selIdx}
          setSelectIndex={setSelIdx}
        />
      </Grid>
      {dlg}
    </Grid>
  );
};

export default AlarmHistoryPage;
